function updateQueryParam(key, value, currentUrl) {
  const url = new URL(currentUrl);
  url.searchParams.set(key, value); 
  return url.toString();
}

function removeQueryParam(key, currentUrl) {
  const url = new URL(currentUrl);
  url.searchParams.delete(key);
  return url.toString();
}

export function newRelativeUrlWith(key, value) {
  const updatedUrl = updateQueryParam(key, value, window.location.href);
  const newUrl = new URL(updatedUrl);
  const relativeUrl = newUrl.toString().substring(newUrl.origin.length);
  return relativeUrl;
}

export function newRelativeUrlWithout(key) {
  const updatedUrl = removeQueryParam(key, window.location.href);
  const newUrl = new URL(updatedUrl);
  const relativeUrl = newUrl.toString().substring(newUrl.origin.length);
  return relativeUrl;
}
